// extracted by mini-css-extract-plugin
export default {"defaultExternalLink":"ExternalPageLink-defaultExternalLink"};